<template>
  <div class="w-full h-full px-5 flex flex-col gap-4 pb-5 overflow-hidden gap-2">


    <div class="flex flex-col gap-2">

      <h2>Darstellung:</h2>
      <div
          class=" w-full grid grid-cols-3 flex-wrap rounded overflow-hidden border border-trader-input-border bg-trader-input-border gap-[1px] dark:border-0 dark:bg-trader-darker-gray">
        <button class="flex-grow p-1 transition-colors cursor-pointer flex flex-col justify-center items-center"
                :class="{
          'bg-trader-blue text-white': options.type === 'button-group',
          'bg-white dark:bg-trader-dark-gray': options.type !== 'button-group'
        }"
                @click="options.type = 'button-group'">
          Button Gruppe
        </button>
        <button class="flex-grow p-1 transition-colors cursor-pointer flex flex-col justify-center items-center"
                :class="{
          'bg-trader-blue text-white': options.type === 'drop-down',
          'bg-white dark:bg-trader-dark-gray': options.type !== 'drop-down'
        }"
                @click="options.type = 'drop-down'">
          Drop Down
        </button>

        <button class="flex-grow p-1 transition-colors cursor-pointer flex flex-col justify-center items-center"
                :class="{
          'bg-trader-blue text-white': options.type === 'list',
          'bg-white dark:bg-trader-dark-gray': options.type !== 'list'
        }"
                @click="options.type = 'list'">
          Liste
        </button>

      </div>

      <label class="flex w-1/3">

        <span class="flex-grow">Grafiken sind Symbole nur aus Graustufen:</span>
        <input type="checkbox" class="p-1 w-4 h-4 my-1" v-model="options.hasSymbols">
      </label>

      <label class="flex w-1/3">
        <span class="flex-grow">Erlaube Mehrfachauswahl:</span>
        <input type="checkbox" class="p-1 w-4 h-4 my-1" v-model="options.allowMultiselection">
      </label>

      <div v-if="options.type === 'button-group'">
        <label class="flex w-1/3">
          <span class="flex-grow">Spaltenanzahl:</span>
          <input type="number" step="1" min="1" v-model="options.gridCols">
        </label>
      </div>

    </div>

    <div class="flex-grow overflow-auto bg-trader-input-border dark:bg-trader-darker-gray">

      <table class="w-full">
        <thead>
        <tr>
          <th>Beschriftung</th>
          <th>
            <span v-if="options.allowMultiselection">Eindeutige ID</span>
            <span v-else>Text</span>
          </th>
          <th>(Optional) Original Bild Pfad für den Export</th>

          <th>Grafik</th>
          <th></th>

          <th>Löschen</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(btn, index) in options.buttons" :key="index">
          <td>
            <input v-model="btn.label" class="border w-full p-1" type="text"/>
          </td>

          <td class="text-center">

            <div v-if="index == 0 && !options.allowMultiselection">- wenn leer -</div>
            <input v-else v-model="btn.key" class="border w-full p-1" type="text"/>
          </td>

          <td>
            <input v-model="btn.originalFilePath" class="border w-full p-1" type="text"/>
          </td>

          <td class="w-[64px]">
            <div class="w-[64px] h-[32px] flex justify-center items-center p-1">
              <img v-if="btn.previewFilePath"
                   :src="btn.previewFilePath"
                   style="max-height: 50px;"
                   alt="Preview"
                   :class="{
                     'icon' : options.hasSymbols
                   }"
              />
            </div>
          </td>
          <td>
            <label class="myLabel">
              <i class="fa-solid fa-file-arrow-up"></i>
              <input type="file" @change="onFileChange($event, index)"/>
            </label>
          </td>


          <td class="text-center">
            <button class="p-1" @click="options.buttons.splice(index, 1)">
              <i class="fas fa-times p-2 hover:text-trader-red"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Button zum Hinzufügen eines neuen Elements -->
    <button class="bg-trader-dark-gray p-2 hover:bg-trader-blue hover:text-" @click="addButton">Neuen Option
      hinzufügen
    </button>

    <!-- Aktionen Übernehmen / Abbrechen -->
    <div class="flex w-full gap-5 mt-4">
      <button class="flex-grow bg-trader-green text-trader-dark-green p-2" @click="apply">
        Übernehmen
      </button>
      <button class="flex-grow bg-trader-green text-trader-dark-green p-2" @click="close">
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {eventBus} from "@/application/EventBus";

export default {
  props: {
    setData: {
      type: String,
      default: ''
    },
    onApply: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    let initialValue = {
      type: 'button-group',
      gridCols: 2,
      allowMultiselection: false,
      hasSymbols: false,
      buttons: []
    };
    try {
      // setData enthält das JSON (z. B. aus formField.value)
      initialValue = JSON.parse(this.setData);
    } catch (e) {
      initialValue = {
        type: 'button-group',
        gridCols: 2,
        allowMultiselection: false,
        hasSymbols: false,
        buttons: []
      };
    }
    /*
    if (!Array.isArray(initialValue)) {
      initialValue = [];
    }
    */

    return {
      // Wird als Array von Objekten (Button-Definitionen) verwaltet
      options: initialValue,

      // Hier speichern wir ggf. die File-Objekte pro Index
      selectedFiles: {}
    };
  },
  methods: {
    // Modal schließen ohne zu übernehmen
    close() {
      eventBus.closeModal();
    },

    // Übernehmen-Knopf
    apply() {

      if(!this.options.allowMultiselection) {
        if(this.options.buttons.length >=1) {
          this.options.buttons[0].key = "";
        }
      }

      const saveString = JSON.stringify(this.options);
      this.onApply(saveString);
      eventBus.closeModal();
    },

    // Neues Button-Objekt hinzufügen
    addButton() {
      this.options.buttons.push({
        label: '',
        key: '',
        originalFilePath: '',
        previewFilePath: ''
      });
    },

    // File auswählen
    onFileChange(event, index) {
      const file = event.target.files[0];
      if (!file) return;
      this.selectedFiles[index] = file;
      this.uploadFile(index);
    },

    // Upload ausführen
    async uploadFile(index) {
      if (!this.selectedFiles[index]) {
        alert('Bitte wählen Sie eine Datei aus.');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFiles[index]);

      try {
        const response = await axios.post('/api/v3/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        // Angenommen wir kriegen hier ein Array von Pfaden zurück
        if (response.data.length > 0) {
          this.options.buttons[index].previewFilePath = response.data[0];
        }
      } catch (error) {
        console.error('Fehler beim Hochladen der Datei:', error);
        alert('Fehler beim Hochladen der Datei.');
      }
    },
  }
};
</script>

<style scoped>
.icon {
  filter: invert(0.3);
}

.icon-select {
  filter: invert(1.0);
}

.icon:is(.dark *) {
  filter: invert(1.0);
}


label.myLabel input[type="file"] {
  position: absolute;
  top: -1000px;
}

/***** Example custom styling *****/
.myLabel {
  padding: 2px 5px;
  margin: 2px;
  display: inline-block;
  font-size: 16pt;
}

.myLabel:hover {
}

.myLabel:active {
  background: #CCF;
}

.myLabel :invalid + span {
  color: #A44;
}

.myLabel :valid + span {
  color: #4A4;
}
</style>
